export default __webpack_public_path__ + "static/media/reset.d9d5e750.svg";